import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";

const TABS = [
  { id: "dashboard", labelId: "strategic_analysis.view_report.tab.dashboard", defaultLabel: "Campaign Dashboard" },
  { id: "visuals",   labelId: "strategic_analysis.view_report.tab.visuals",   defaultLabel: "Visual Strategy Deck" },
  { id: "battlecards", labelId: "strategic_analysis.view_report.tab.battlecards", defaultLabel: "Competitor Battlecards" },
  { id: "analysis",  labelId: "strategic_analysis.view_report.tab.analysis",  defaultLabel: "Full Context Report" },
];

const TabNav = ({ activeTab, onTabChange }) => {
  return (
    <div className="sa-tabs-bar">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          id={`sa-tab-${tab.id}`}
          className={`sa-tab-btn${activeTab === tab.id ? " sa-tab-btn--active" : ""}`}
          onClick={() => onTabChange(tab.id)}
          type="button"
        >
          <FormattedMessage id={tab.labelId} defaultMessage={tab.defaultLabel} />
        </button>
      ))}
    </div>
  );
};

export default TabNav;
